import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpenNativeSettings } from '@awesome-cordova-plugins/open-native-settings/ngx';
import { SafeUrlPipe } from './safe-url.pipe';

@NgModule({
  declarations: [SafeUrlPipe],
  exports: [SafeUrlPipe],
  imports: [CommonModule],
  providers: [OpenNativeSettings],
})
export class SharedModule {}
